import type { HydrationOptions } from 'react-dom/client';

import { captureSentryException } from './sentry';

// React calls onRecoverableError when it recovers without unmounting, e.g. a
// hydration mismatch that triggers a client re-render. Log it (visible in
// Cypress cons:error output) and report it: the page works, but a recovered
// error still means the server-rendered work was thrown away and event
// handlers can end up on the wrong elements.
const onRecoverableError: NonNullable<HydrationOptions['onRecoverableError']> = (error, { componentStack }) => {
  console.error('[POPMENU] Recoverable React error:', error, 'Component stack:', componentStack);
  captureSentryException(error, { componentStack, reactRecoverable: true });
};

export default onRecoverableError;
